import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faEye } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Container, Row, Col, Table} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { FetchAllPatients } from "src/Thunk/adminThunks";
const PatientList = () => {
  const dispatch = useDispatch();
  const { patientList } = useSelector((state) => state.admin);
  const [searchTerm, setSearchTerm] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  let itemsPerPage = 10;

  useEffect(() => {
    dispatch(FetchAllPatients());
  }, []);

  const filteredPatients = patientList.filter((customer) =>
    Object.values(customer).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchTerm.toLowerCase())
    )
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredPatients.slice(
    indexOfFirstItem,
    indexOfLastItem
  );

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // const handleDeleteUser = async (userId) => {
  //   try {
  //     const response = await fetch(Constants.deletePatient + userId, {
  //       method: "DELETE",
  //     });
  //     if (response.ok) {
  //       setPatients(patients.filter((patient) => patient._id !== userId));
  //       MySwal.fire({
  //         icon: "success",
  //         title: "Patient Deleted!",
  //         text: "The patient has been successfully deleted.",
  //       });
  //     } else {
  //       console.error("Failed to delete patient");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting patient:", error);
  //   }
  // };

  return (
    <div className="main-content">
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col>
              <div className="page-title-box d-flex align-items-center justify-content-between">
                <h4 className="mb-0 text-info">PATIENT INFORMATION LIST</h4>
                <div className="page-title-right">
                  <ol className="breadcrumb m-0">
                    <li className="breadcrumb-item">
                      <Link to="/dashboard">Home</Link>
                    </li>
                    <li className="breadcrumb-item text-info active">
                      Patient Info List
                    </li>
                  </ol>
                </div>
              </div>
            </Col>
          </Row>

          <Row>
            <Col>
              <div className="card custom-shadow rounded-lg border my-3">
                <div className="card-body">
                  <Row>
                    <Col md={4} xs={12} className="mb-3 text-center">
                      <h3 className="fw-bolder text-info mb-0">
                        {patientList.length}
                      </h3>
                      <p className="text-secondary">Total Recorded Patient Information</p>
                    </Col>
                  </Row>

                  <div className="dataTables_length mb-2">
                    <div className="search-box">
                      <input
                        type="text"
                        id="search"
                        placeholder="Search "
                        name="search"
                        className="form-control "
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="table-responsive">
                    <Table responsive bordered22 hover>
                      <thead>
                        <tr>
                        <th>PatientId</th>
                          <th>Name</th>
                          <th>DOB</th>
                          <th>Email</th>
                          <th>Domicile</th>
                          <th>Mobile No</th>
                          <th>Marital Status</th>
                          <th>Actions</th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems?.map((patient, index) => (
                          <tr key={patient?._id}>
                            <td>{patient?.PatientId}</td>
                            <td>{patient?.Name_Surname}</td>
                            <td>{patient?.DOB}</td>
                            <td>{patient?.mail}</td>
                            <td>{patient?.Domicile}</td>
                            <td>{patient?.Mobilephone}</td>
                            <td>{patient?.Maritalstatus}</td>
                        
                            <td>
                              <div className="icon-container">
                                {/* <Button
                                  variant="danger"
                                  size="sm"
                                  title="Delete Patient Info"
                                  onClick={() => {
                                    MySwal.fire({
                                      title: "Are you sure?",
                                      text: "Once deleted, you will not be able to recover this user!",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonText: "Yes, delete it!",
                                      cancelButtonText: "No, cancel!",
                                      reverseButtons: true,
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        handleDeleteUser(patient._id);
                                      }
                                    });
                                  }}
                                >
                                  <FontAwesomeIcon icon={faTrash} />
                                </Button> */}
                                <Link
                                  className="btn btn-sm btn-info text-white"
                                  state={patient}
                                  title="view patient info"
                                  to={`/patientDetails/${patient._id}`}
                                >
                                  <FontAwesomeIcon icon={faEye} />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                  <Container>
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_length">
                        Showing {indexOfFirstItem + 1} to{" "}
                        {Math.min(indexOfLastItem, patientList.length)} of{" "}
                        {patientList.length} entries
                      </div>
                    </div>
                    <div>
                      {Array.from({
                        length: Math.ceil(patientList.length / itemsPerPage),
                      }).map((_, index) => (
                        <button
                          key={index}
                          type="button"
                         className="btn btn-primary btn-circle btn-sm text-white m-1"
                          onClick={() => paginate(index + 1)}
                        >
                          {index + 1}
                        </button>
                      ))}
                    </div>
                  </Container>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default PatientList;
